// extracted by mini-css-extract-plugin
module.exports = {"summaryContainer":"NonPlanYearServiceSummary_summaryContainer__aLa6u","dataSection":"NonPlanYearServiceSummary_dataSection__2FJ96"};